const CYRILLIC_TO_LATIN = {
  '\u0410': 'A',
  '\u0411': 'B',
  '\u0412': 'V',
  '\u0413': 'G',
  '\u0414': 'D',
  '\u0415': 'E',
  '\u0401': 'E',
  '\u0416': 'Zh',
  '\u0417': 'Z',
  '\u0418': 'I',
  '\u0419': 'Y',
  '\u041a': 'K',
  '\u041b': 'L',
  '\u041c': 'M',
  '\u041d': 'N',
  '\u041e': 'O',
  '\u041f': 'P',
  '\u0420': 'R',
  '\u0421': 'S',
  '\u0422': 'T',
  '\u0423': 'U',
  '\u0424': 'F',
  '\u0425': 'Kh',
  '\u0426': 'Ts',
  '\u0427': 'Ch',
  '\u0428': 'Sh',
  '\u0429': 'Sch',
  '\u042a': '',
  '\u042b': 'Y',
  '\u042c': '',
  '\u042d': 'E',
  '\u042e': 'Yu',
  '\u042f': 'Ya',
  '\u0430': 'a',
  '\u0431': 'b',
  '\u0432': 'v',
  '\u0433': 'g',
  '\u0434': 'd',
  '\u0435': 'e',
  '\u0451': 'e',
  '\u0436': 'zh',
  '\u0437': 'z',
  '\u0438': 'i',
  '\u0439': 'y',
  '\u043a': 'k',
  '\u043b': 'l',
  '\u043c': 'm',
  '\u043d': 'n',
  '\u043e': 'o',
  '\u043f': 'p',
  '\u0440': 'r',
  '\u0441': 's',
  '\u0442': 't',
  '\u0443': 'u',
  '\u0444': 'f',
  '\u0445': 'kh',
  '\u0446': 'ts',
  '\u0447': 'ch',
  '\u0448': 'sh',
  '\u0449': 'sch',
  '\u044a': '',
  '\u044b': 'y',
  '\u044c': '',
  '\u044d': 'e',
  '\u044e': 'yu',
  '\u044f': 'ya'
};

export function transliterate(value) {
  return String(value ?? '')
    .split('')
    .map(char => CYRILLIC_TO_LATIN[char] ?? char)
    .join('');
}

export function localizedDisplayValue(value, locale) {
  const text = String(value ?? '');
  return locale === 'en' ? transliterate(text) : text;
}

export function localizedEntityValue(value, valueEn, locale) {
  const text = String(value ?? '');
  const englishText = String(valueEn ?? '').trim();

  if (locale === 'en' && englishText) {
    return englishText;
  }

  return localizedDisplayValue(text, locale);
}
